export const enum DEBUG {
  FETCHING_INTERVIEW = 'Fetching interview data',
  INTERVIEW_DATA_RECEIVED = 'Interview data received',
  FETCHING_INTERVIEW_ERROR = 'Failed to fetch interview',
  WELCOME_PAGE_STAGE = 'In welcome page stage',
  SETUP_STAGE = 'In setup stage',
  MEIDA_DEVICE_SUCCESS = 'Media device available',
  MEDIA_DEVICE_SWITCH_OFF = 'Media device is off',
  MEDIA_DEVICE_ERROR = 'Media device error',
  NO_SOUND_DETECTED = 'No sound detected',
  DEVICE_CHANGED = 'Device changed',
  SPEED_TEST_DONE = 'Speed test result received',
  PRACTICE_STARTED = 'Practice started',
  INTERVIEW_STARTED = 'Interview started',
  RETAKE_CLICKED = 'Retake clicked',
  QUESTION_SUBMITTED = 'Qeustion submitted',
  UPLOADING_STATE = 'In uploading state',
  UPLOAD_COMPLETED = 'Upload completed',
  INTERVIEW_SUBMITTED = 'Interview submitted successfully',
}
